import React from 'react';
import { string, object } from 'prop-types';
import Row from '../Container/Row';
import { CaptionText } from '../Text/Heading';
import Icon from '../Icon';

const BigPointNote = ({ noteMsg, style }) => {
  const { marginTop = '0px' } = style;
  return (
    noteMsg && (
      <Row marginTop={marginTop}>
        <Icon icon="InfoOutlinedIcon" fontsize="titleSmall" />
        <CaptionText color="greyDarker" marginLeft={'6px'} lineHeight={'18px'}>
          {noteMsg}
        </CaptionText>
      </Row>
    )
  );
};

BigPointNote.propTypes = {
  noteMsg: string,
  style: object,
};

BigPointNote.defaultProps = {
  noteMsg: '',
  style: {},
};

export default BigPointNote;
